import { consolidateStreamedStyles } from 'styled-components';
// import messagesCS from './cs';
// import messagesEN from './en';
// import messagesRU from './ru';

// const messages = [messagesCS, messagesEN, messagesRU];
const messages = (language) => {
  if (language === 'cs') {
    return import(/* webpackChunkName: "messages-cs" */ './cs').then((m) => m.default);
  } else if (language === 'ru') {
    return import(/* webpackChunkName: "messages-ru" */ './ru').then((m) => m.default);
  } else if (language === 'es') {
    return import(/* webpackChunkName: "messages-ru" */ './es').then((m) => m.default);
  } else if (language === 'fr') {
    return import(/* webpackChunkName: "messages-fr" */ './fr').then((m) => m.default);
  } else if (language === 'uk') {
    return import(/* webpackChunkName: "messages-uk" */ './uk').then((m) => m.default);
  } else {
    return import(/* webpackChunkName: "messages-en" */ './en').then((m) => m.default);
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/messages/index.js